import PropTypes from 'prop-types'
import React from 'react'

import Brand from './Brand'
import Nav from './Nav'
import PageLink from './PageLink'
import Wrapper from './Wrapper'

const Header = ({ title }) => (
  <Wrapper>
    <Brand brand={title}>{title.toUpperCase()}</Brand>
    <Nav>
      <PageLink href="#services" alt="services">
        Services
      </PageLink>
      <PageLink href="#contact" alt="services">
        Contact
      </PageLink>
    </Nav>
  </Wrapper>
)

Header.propTypes = {
  title: PropTypes.string,
}

Header.defaultProps = {
  title: `Title`,
}

export default Header



// WEBPACK FOOTER //
// ./src/containers/Layout/Header/Header.js